import type { AboutTab } from '../types'

/** Tab 配置（顺序与 Figma / H5 对齐） */
export const ABOUT_TABS: AboutTab[] = [
  { key: 'about-us', labelKey: 'About Us' },
  { key: 'faq', labelKey: '常见问题' },
  { key: 'rules-regulations', labelKey: '规则与条例' },
  { key: 'terms', labelKey: '条款与条件' },
  { key: 'rebate', labelKey: '返水' },
  { key: 'privacy-policy', labelKey: '隐私政策条款' },
  { key: 'responsible-gaming', labelKey: '负责任博彩' },
  { key: 'general-promotion-terms', labelKey: '通用促销条款' },
  { key: 'kyc', labelKey: 'KYC Policy' }
]
